import React, { useState } from 'react';
import { CheckSquare, Clock, User, Users, Calendar } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { useToast } from '../../context/ToastContext';
interface OnboardingProps {
  isManager?: boolean;
}
export function Onboarding({
  isManager = false
}: OnboardingProps) {
  const [isNewOnboardingModalOpen, setIsNewOnboardingModalOpen] = useState(false);
  const [newEmployee, setNewEmployee] = useState({
    name: '',
    position: '',
    startDate: '',
    email: ''
  });
  const {
    showToast
  } = useToast();
  // Mock data
  const tasks = [{
    id: 1,
    title: "Compléter le formulaire d'accueil",
    status: 'completed',
    dueDate: '1 nov. 2023',
    assignedTo: 'Vous'
  }, {
    id: 2,
    title: 'Configurer le poste de travail',
    status: 'completed',
    dueDate: '2 nov. 2023',
    assignedTo: 'IT'
  }, {
    id: 3,
    title: "Rencontrer l'équipe",
    status: 'in-progress',
    dueDate: '3 nov. 2023',
    assignedTo: 'Manager'
  }, {
    id: 4,
    title: 'Formation initiale',
    status: 'pending',
    dueDate: '5 nov. 2023',
    assignedTo: 'RH'
  }, {
    id: 5,
    title: 'Définir les objectifs',
    status: 'pending',
    dueDate: '10 nov. 2023',
    assignedTo: 'Manager'
  }];
  const managerOnboardings = [{
    id: 1,
    employee: 'Thomas Petit',
    position: 'Développeur Frontend',
    startDate: '1 nov. 2023',
    progress: 40,
    tasks: [{
      id: 101,
      title: "Présenter à l'équipe",
      status: 'completed'
    }, {
      id: 102,
      title: 'Définir les objectifs initiaux',
      status: 'in-progress'
    }, {
      id: 103,
      title: 'Planifier les formations',
      status: 'pending'
    }]
  }, {
    id: 2,
    employee: 'Camille Roux',
    position: 'Designer UX',
    startDate: '15 nov. 2023',
    progress: 0,
    tasks: [{
      id: 201,
      title: 'Préparer le poste de travail',
      status: 'pending'
    }, {
      id: 202,
      title: "Planifier la journée d'accueil",
      status: 'pending'
    }, {
      id: 203,
      title: 'Assigner un mentor',
      status: 'pending'
    }]
  }];
  const completedTasks = tasks.filter(task => task.status === 'completed').length;
  const totalTasks = tasks.length;
  const progressPercentage = Math.round(completedTasks / totalTasks * 100);
  const handleCreateOnboarding = () => {
    if (!newEmployee.name || !newEmployee.position || !newEmployee.startDate) {
      showToast('Veuillez remplir tous les champs obligatoires', 'error');
      return;
    }
    showToast(`Onboarding créé pour ${newEmployee.name}`, 'success');
    setIsNewOnboardingModalOpen(false);
    setNewEmployee({
      name: '',
      position: '',
      startDate: '',
      email: ''
    });
  };
  return <div data-id="element-847">
      <div className="mb-6" data-id="element-848">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-849">
          {isManager ? 'Gestion Onboarding/Offboarding' : 'Mon Onboarding'}
        </h1>
        <p className="text-gray-600" data-id="element-850">
          {isManager ? "Suivez et gérez l'intégration de vos nouveaux collaborateurs" : "Suivez votre progression et complétez vos tâches d'intégration"}
        </p>
      </div>
      {isManager ? <div data-id="element-851">
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-852">
            <div className="flex justify-between items-center mb-6" data-id="element-853">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-854">
                Onboardings en cours
              </h2>
              <button onClick={() => setIsNewOnboardingModalOpen(true)} className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700" data-id="element-855">
                + Nouvel onboarding
              </button>
            </div>
            <div className="space-y-6" data-id="element-856">
              {managerOnboardings.map(onboarding => <div key={onboarding.id} className="border border-gray-200 rounded-lg p-5" data-id="element-857">
                  <div className="flex justify-between items-start mb-4" data-id="element-858">
                    <div className="flex items-center" data-id="element-859">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-medium" data-id="element-860">
                        {onboarding.employee.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div className="ml-3" data-id="element-861">
                        <h3 className="font-medium text-gray-900" data-id="element-862">
                          {onboarding.employee}
                        </h3>
                        <p className="text-sm text-gray-600" data-id="element-863">
                          {onboarding.position}
                        </p>
                      </div>
                    </div>
                    <div className="text-right" data-id="element-864">
                      <div className="text-sm font-medium text-gray-900" data-id="element-865">
                        Début: {onboarding.startDate}
                      </div>
                      <div className="text-sm text-gray-600" data-id="element-866">
                        Progression: {onboarding.progress}%
                      </div>
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4" data-id="element-867">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{
                width: `${onboarding.progress}%`
              }} data-id="element-868"></div>
                  </div>
                  <div className="space-y-3 mb-4" data-id="element-869">
                    <h4 className="font-medium text-gray-900 text-sm" data-id="element-870">
                      Tâches assignées au manager:
                    </h4>
                    {onboarding.tasks.map(task => <div key={task.id} className="flex items-center" data-id="element-871">
                        <div className={`flex-shrink-0 h-5 w-5 rounded-full border ${task.status === 'completed' ? 'bg-green-500 border-green-500' : task.status === 'in-progress' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center mr-3`} data-id="element-872">
                          {task.status === 'completed' && <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-873">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-874" />
                            </svg>}
                        </div>
                        <span className={`text-sm ${task.status === 'completed' ? 'text-gray-500 line-through' : 'text-gray-700'}`} data-id="element-875">
                          {task.title}
                        </span>
                        {task.status === 'in-progress' && <span className="ml-auto text-xs px-2 py-1 bg-blue-100 text-blue-800 rounded-full" data-id="element-876">
                            En cours
                          </span>}
                        {task.status === 'pending' && <button className="ml-auto text-xs px-2 py-1 border border-blue-500 text-blue-600 rounded hover:bg-blue-50" data-id="element-877">
                            Démarrer
                          </button>}
                      </div>)}
                  </div>
                  <div className="flex justify-end space-x-3" data-id="element-878">
                    <button className="px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" data-id="element-879">
                      Détails
                    </button>
                    <button className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700" data-id="element-880">
                      Gérer
                    </button>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-881">
            <div className="flex justify-between items-center mb-6" data-id="element-882">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-883">
                Offboardings planifiés
              </h2>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700" data-id="element-884">
                + Nouvel offboarding
              </button>
            </div>
            <div className="text-center py-10" data-id="element-885">
              <div className="mx-auto h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-886">
                <Users className="h-6 w-6 text-gray-400" data-id="element-887" />
              </div>
              <h3 className="text-gray-900 font-medium mb-1" data-id="element-888">
                Aucun offboarding planifié
              </h3>
              <p className="text-gray-500" data-id="element-889">
                Il n'y a pas de départ prévu dans votre équipe actuellement.
              </p>
            </div>
          </div>
        </div> : <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-890">
          {/* Left column - Progress */}
          <div className="lg:col-span-1 space-y-6" data-id="element-891">
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-892">
              <div className="flex items-center justify-between mb-4" data-id="element-893">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-894">
                  Ma progression
                </h2>
                <User className="h-5 w-5 text-blue-600" data-id="element-895" />
              </div>
              <div className="mb-6" data-id="element-896">
                <div className="flex justify-between mb-1" data-id="element-897">
                  <span className="text-sm text-gray-600" data-id="element-898">
                    Progression globale
                  </span>
                  <span className="text-sm font-medium text-gray-700" data-id="element-899">
                    {progressPercentage}%
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-900">
                  <div className="bg-blue-600 h-2.5 rounded-full" style={{
                width: `${progressPercentage}%`
              }} data-id="element-901"></div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-902">
                <div className="bg-green-50 p-3 rounded text-center" data-id="element-903">
                  <span className="block text-xl font-semibold text-green-600" data-id="element-904">
                    {completedTasks}
                  </span>
                  <span className="text-xs text-green-800" data-id="element-905">
                    Tâches complétées
                  </span>
                </div>
                <div className="bg-blue-50 p-3 rounded text-center" data-id="element-906">
                  <span className="block text-xl font-semibold text-blue-600" data-id="element-907">
                    {totalTasks - completedTasks}
                  </span>
                  <span className="text-xs text-blue-800" data-id="element-908">
                    Tâches restantes
                  </span>
                </div>
              </div>
              <div className="border-t border-gray-100 pt-4" data-id="element-909">
                <h3 className="font-medium text-gray-900 mb-3" data-id="element-910">
                  Contacts clés
                </h3>
                <div className="space-y-3" data-id="element-911">
                  <div className="flex items-center" data-id="element-912">
                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-medium text-sm" data-id="element-913">
                      JM
                    </div>
                    <div className="ml-3" data-id="element-914">
                      <p className="text-sm font-medium text-gray-900" data-id="element-915">
                        Jean Martin
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-916">Manager</p>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-917">
                    <div className="h-8 w-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-800 font-medium text-sm" data-id="element-918">
                      SB
                    </div>
                    <div className="ml-3" data-id="element-919">
                      <p className="text-sm font-medium text-gray-900" data-id="element-920">
                        Sophie Bernard
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-921">RH</p>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-922">
                    <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center text-green-800 font-medium text-sm" data-id="element-923">
                      MD
                    </div>
                    <div className="ml-3" data-id="element-924">
                      <p className="text-sm font-medium text-gray-900" data-id="element-925">
                        Marie Dupont
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-926">Mentor</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-927">
              <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-928">
                Ressources utiles
              </h2>
              <div className="space-y-3" data-id="element-929">
                <div className="border border-gray-200 rounded-lg p-3 hover:border-blue-300 hover:bg-blue-50 transition-colors duration-150 cursor-pointer" data-id="element-930">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-931">
                    Guide du nouvel employé
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-932">
                    Tout ce que vous devez savoir pour bien démarrer
                  </p>
                </div>
                <div className="border border-gray-200 rounded-lg p-3 hover:border-blue-300 hover:bg-blue-50 transition-colors duration-150 cursor-pointer" data-id="element-933">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-934">
                    Organigramme
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-935">
                    Structure de l'entreprise et des équipes
                  </p>
                </div>
                <div className="border border-gray-200 rounded-lg p-3 hover:border-blue-300 hover:bg-blue-50 transition-colors duration-150 cursor-pointer" data-id="element-936">
                  <h3 className="text-sm font-medium text-gray-900" data-id="element-937">
                    FAQ nouvel arrivant
                  </h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-938">
                    Réponses aux questions fréquentes
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Right column - Tasks */}
          <div className="lg:col-span-2" data-id="element-939">
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-940">
              <div className="flex justify-between items-center mb-6" data-id="element-941">
                <h2 className="text-lg font-semibold text-gray-900" data-id="element-942">
                  Mes tâches d'onboarding
                </h2>
                <CheckSquare className="h-5 w-5 text-blue-600" data-id="element-943" />
              </div>
              <div className="space-y-4" data-id="element-944">
                {tasks.map(task => <div key={task.id} className="border border-gray-200 rounded-lg p-4" data-id="element-945">
                    <div className="flex items-start" data-id="element-946">
                      <div className={`flex-shrink-0 h-6 w-6 rounded-full border ${task.status === 'completed' ? 'bg-green-500 border-green-500' : task.status === 'in-progress' ? 'border-blue-500' : 'border-gray-300'} flex items-center justify-center mr-3 mt-0.5`} data-id="element-947">
                        {task.status === 'completed' && <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 20 20" data-id="element-948">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-949" />
                          </svg>}
                      </div>
                      <div className="flex-grow" data-id="element-950">
                        <h3 className={`font-medium ${task.status === 'completed' ? 'text-gray-500 line-through' : 'text-gray-900'}`} data-id="element-951">
                          {task.title}
                        </h3>
                        <div className="flex flex-wrap gap-x-4 mt-2 text-sm text-gray-600" data-id="element-952">
                          <div className="flex items-center" data-id="element-953">
                            <Clock className="h-4 w-4 mr-1 text-gray-400" data-id="element-954" />
                            <span data-id="element-955">Échéance: {task.dueDate}</span>
                          </div>
                          <div className="flex items-center" data-id="element-956">
                            <User className="h-4 w-4 mr-1 text-gray-400" data-id="element-957" />
                            <span data-id="element-958">Assigné à: {task.assignedTo}</span>
                          </div>
                        </div>
                      </div>
                      <div className="ml-4" data-id="element-959">
                        {task.status === 'completed' && <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs" data-id="element-960">
                            Complété
                          </span>}
                        {task.status === 'in-progress' && <div className="flex flex-col items-end space-y-2" data-id="element-961">
                            <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs" data-id="element-962">
                              En cours
                            </span>
                            <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-963">
                              Terminer
                            </button>
                          </div>}
                        {task.status === 'pending' && task.assignedTo === 'Vous' && <button className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700" data-id="element-964">
                              Démarrer
                            </button>}
                        {task.status === 'pending' && task.assignedTo !== 'Vous' && <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded-full text-xs" data-id="element-965">
                              En attente
                            </span>}
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>}
      <Modal isOpen={isNewOnboardingModalOpen} onClose={() => setIsNewOnboardingModalOpen(false)} title="Créer un nouvel onboarding" size="md" data-id="element-966">
        <div className="space-y-4" data-id="element-967">
          <div data-id="element-968">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-969">
              Nom de l'employé *
            </label>
            <input type="text" value={newEmployee.name} onChange={e => setNewEmployee({
            ...newEmployee,
            name: e.target.value
          })} className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors" placeholder="Ex: Jean Dupont" data-id="element-970" />
          </div>
          <div data-id="element-971">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-972">
              Poste *
            </label>
            <input type="text" value={newEmployee.position} onChange={e => setNewEmployee({
            ...newEmployee,
            position: e.target.value
          })} className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors" placeholder="Ex: Développeur Frontend" data-id="element-973" />
          </div>
          <div data-id="element-974">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-975">
              Date de début *
            </label>
            <div className="relative" data-id="element-976">
              <input type="date" value={newEmployee.startDate} onChange={e => setNewEmployee({
              ...newEmployee,
              startDate: e.target.value
            })} className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors appearance-none" data-id="element-977" />
              <Calendar className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" data-id="element-978" />
            </div>
          </div>
          <div data-id="element-979">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-980">
              Email
            </label>
            <input type="email" value={newEmployee.email} onChange={e => setNewEmployee({
            ...newEmployee,
            email: e.target.value
          })} className="w-full px-4 py-3 text-base border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-0 transition-colors" placeholder="jean.dupont@example.com" data-id="element-981" />
          </div>
          <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4" data-id="element-982">
            <button onClick={() => setIsNewOnboardingModalOpen(false)} className="w-full sm:w-auto px-6 py-3 border-2 border-gray-300 rounded-lg text-base font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-983">
              Annuler
            </button>
            <button onClick={handleCreateOnboarding} className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg text-base font-medium hover:bg-blue-700 transition-colors" data-id="element-984">
              Créer l'onboarding
            </button>
          </div>
        </div>
      </Modal>
    </div>;
}